// 权限管理
const tenant = () => import(/* webpackChunkName: "permissions" */ '../../views/permissions/tenant'), // 科室管理
    role = () => import(/* webpackChunkName: "permissions" */ '../../views/permissions/role'), // 科室管理
    dataSource = () => import(/* webpackChunkName: "permissions" */ '../../views/permissions/dataSource'), // 科室管理
    dataSourceAddEdit = () => import(/* webpackChunkName: "permissions" */ '../../views/permissions/dataSource/addEdit'); // 科室管理
export default [
    {
        path: '/permissions/tenant',
        name: 'tenant',
        meta: { title: '租户管理',selfFlg: 'tenant', },

        component: tenant
    },
    {
        path: '/permissions/role',
        name: 'role',
        meta: { title: '角色管理',selfFlg: 'role', },

        component: role
    },
    {
        path: '/permissions/dataSource',
        name: 'dataSource',
        meta: { title: '数据源管理', selfFlg: 'datasource', },

        component: dataSource
    },
    {
        path: '/permissions/dataSource/addEdit',
        name: 'dataSourceAddEdit',
        meta: { title: '数据源管理（新增/编辑）' },
        component: dataSourceAddEdit
    }
];
